import type { AccountSubscription } from '@payaca/types/subscriptionTypes';
import { action } from 'typesafe-actions';
import { SubscriptionActionTypes } from './subscriptionTypes';

export const requestGetAccountSubscription = () => {
  return action(SubscriptionActionTypes.REQUEST_GET_ACCOUNT_SUBSCRIPTION);
};

export const clearAccountSubscription = () => {
  return action(SubscriptionActionTypes.CLEAR_ACCOUNT_SUBSCRIPTION);
};

export const getAccountSubscriptionSuccess = (
  accountSubscription: AccountSubscription
) => {
  return action(SubscriptionActionTypes.GET_ACCOUNT_SUBSCRIPTION_SUCCESS, {
    accountSubscription,
  });
};

export const getAccountSubscriptionFailure = (error: Error) => {
  return action(
    SubscriptionActionTypes.GET_ACCOUNT_SUBSCRIPTION_FAILURE,
    null,
    null,
    error
  );
};
